import { createContext, useContext } from 'react'

import type { KinerjaTipe } from 'types/kinerja'

type KinerjaTipeContext = {
  tipe?: KinerjaTipe
}

export const KinerjaTipeContext = createContext<KinerjaTipeContext>({})

export default function useKinerjaTipeContext() {
  const context = useContext(KinerjaTipeContext)

  return context
}
